// Arabic strings for the hardening stream — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until
// decision H-10.
import type { enHardening } from './en-hardening.ts';
import type { Message } from './types.ts';

export const arHardening: { readonly [K in keyof typeof enHardening]: Message } = {
  // ------------------------------------------------------------ re-seal runs (PD-791)
  'ops.run.reseal': 'إعادة تشفير الأسرار المخزنة',
  // ------------------------------------------------------------ identity-provider destinations (PD-795)
  'set.k.identity.allowPrivateNetworks.label': 'موفرو الهوية على الشبكات الخاصة',
  'set.k.identity.allowPrivateNetworks.help': 'السماح لموفري تسجيل الدخول (OIDC وSAML) والأدلة (LDAP) بالعمل على عناوين شبكات خاصة أو عناوين الاسترجاع المحلي، مثل خادم ADFS داخلي. تُرفض دائمًا عناوين الربط المحلي وعناوين بيانات السحابة الوصفية.',
  'v.endpointPrivateNetwork': 'هذا العنوان على شبكة خاصة. يجب أن يسمح مسؤول النظام أولًا بموفري الهوية على الشبكات الخاصة.',
  'v.endpointBlocked': 'لا يمكن استخدام هذا العنوان (شبكة ربط محلي أو بيانات وصفية أو شبكة محجوزة).',
  'directory.error.destination_refused': 'عنوان الدليل غير مسموح به (الشبكات الخاصة غير مفعّلة، أو عنوان محظور)',
};
